export default __webpack_public_path__ + "hero-732c05cf74ddbf80681adfee79a1143d.digested.webp";